import React, {useEffect, useRef, useState} from "react";
import { ROOT_URL } from "../../../../config/url";
import {useList, useAction, useUnroll, useObject,} from "@vokymlak/kabinet-ui";
import {useParams} from "react-router-dom";

function useProductionOrder() {
  let { productionOrderUuid } = useParams();

  const {
    object: [object],
    update: [isUpdateObject, setIsUpdateObject, updateObject],
  } = useObject({
    apiUrl: "/api/production-order/" + productionOrderUuid,
    rootUrl: ROOT_URL,
  });

  const {unrolls, isUnroll, changeUnroll, changeAllUnroll} = useUnroll();

  useAction([productionOrderUuid], () => updateObject());

  const [isModalObjectAdd, setIsModalObjectAdd] = useState(false);
  const [modalItemEdit, setModalItemEdit] = useState(null);
  const [modalOrderItem2Add, setModalOrderItem2Add] = useState(null);
  const [modalOrderItem3Edit, setModalOrderItem3Edit] = useState(null);

  const [modalAddBoning, setModalAddBoning] = useState(null);
  const [modalItemTransaction, setModalItemTransaction] = useState(null);
  const [modalItemTransactionRollback, setModalItemTransactionRollback] = useState(null);


  const [modalNomenclaturePrint, setModalNomenclaturePrint] = useState(null);
  const [modalOrderEditAction, setModalOrderEditAction] = useState(null);

  return {
    object,
    productionOrderUuid,

    setIsUpdateObject,
    isUpdateObject,

    unrolls,
    isUnroll,
    changeUnroll,
    changeAllUnroll,

    isModalObjectAdd, setIsModalObjectAdd,
    modalItemEdit, setModalItemEdit,
    modalOrderItem2Add, setModalOrderItem2Add,
    modalOrderItem3Edit, setModalOrderItem3Edit,

    modalAddBoning, setModalAddBoning,

    modalItemTransaction, setModalItemTransaction,
    modalItemTransactionRollback, setModalItemTransactionRollback,

    modalOrderEditAction, setModalOrderEditAction,
    modalNomenclaturePrint, setModalNomenclaturePrint,
  };
}

export default useProductionOrder;
